import { Endpoints } from "../../contants/endpoints";
import { api } from "../../lib/api";

export interface IProduct {
  id: string;
  productName: string;
  productCode: string | null;
  brandName: string | null;
  categoryName: string | null;
  stockQuantity: number;
  price: number;
  image: string | null;
  imagesStr: string | null;
  images: string[];
}

export interface SearchProductParams {
  pageIndex?: number;
  pageSize?: number;
  orderBy?: string;
  orderDirection?: string;
  keyword?: string;
  productCategoryIds?: string[];
  brandIds?: string[];
  inventoryStatus?: number;
  storeId?: string | null;
}

export interface IProductItem {
  id: string;
  productName: string;
  categoryId: string;
  categoryName: string;
  brandId: string;
  brandName: string | null;
  decription: string | null;
  discount: number | null;
  quantity: number;
  price: number | null;
  originalPrice: number | null;
  status: string | null;
  images: (string | null)[];
  isFavourite: boolean;
  productOnSale: boolean;
  flashSaleEndDate: string | null;
  flashSaleMaxQuantity: number;
  productCode?: string;
}

export interface ProductSearchRelatedParams {
  orderBy: string | null;
  orderDirection: string | null;
  pageIndex: number;
  pageSize: number;
  productId: string;
  keyword: string | null;
}

const storeID = process.env.NEXT_PUBLIC_STORE_ID;

export async function getSearchTopSale() {
  try {
    const res = await api.get(`${Endpoints?.product?.topSale}?id=${storeID}`);
    if (res.data && res?.data?.success) {
      return res?.data?.data;
    } else {
      return [];
    }
  } catch (error) {
    console.error("API search list error:", error);
    return [];
  }
}

export async function getSearchProduct(params: SearchProductParams): Promise<{
  data: IProduct[];
  total: number;
}> {
  try {
    const res = (await api.post(Endpoints.product.searchProduct, {
      ...params,
      storeId: storeID,
    })) as any;

    const body = res?.data;


    if (body?.success) {
      return {
        data: body?.data ?? [],
        total: body?.objCount ?? 0,
      };
    }

    return {
      data: [],
      total: 0,
    };
  } catch (error) {
    console.error("API search list error:", error);
    return {
      data: [],
      total: 0,
    };
  }
}

export async function getDetailProduct(
  id: string
): Promise<IProductItem | null> {
  try {
    const res = (await api.post(Endpoints.product.detailProduct, {
      productId: id,
      storeId: storeID,
    })) as any;
    const data = res?.data;

    if (data?.success && data?.data) {
      return data?.data;
    }

    return null;
  } catch (error) {
    console.error("API search list error:", error);
    return null;
  }
}

export async function getSearchRelatedProduct(
  params: ProductSearchRelatedParams
): Promise<IProduct[]> {
  try {
    const res = (await api.post(Endpoints.product.related, {
      ...params,
      // storeId: storeID,
    })) as any;

    const data = res?.data;

    if (data?.success && data?.data) {
      return data?.data;
    }

    return [];
  } catch (error) {
    console.error("API search list error:", error);
    return [];
  }
}
